export enum ToasterVariants {
    primary = "primary",
    success = "success",
    warning = "warning",
    danger = "danger",
}
export type ToasterVariant = `${ToasterVariants}`;

// Define the interface for the addToaster action
export interface AddToasterPayload {
    message: string;
    variant: ToasterVariant;
    duration: number;
    dismissible: boolean;
}

// Define the interface for the removeToaster action
export interface RemoveToasterPayload {
    id: string;
}

// Define the shape of an individual toaster in the Redux store
export interface ToasterItem extends AddToasterPayload {
    // Add an id property to uniquely identify each toaster
    id: string;
}

export interface ToasterStoreState {
    toasters: ToasterItem[];
}
